module.exports = __webpack_public_path__ + "media/images/checkout/challenger/learn_more_3-f5c7c8307484db9c732e93ac377b4b78.png";